export const typeDelivery = {
	farmacia: 'Retiro en farmacia',
	domicilio: 'Con envío a domicilio',
};
